module.exports = __webpack_public_path__ + "img/birthday-2015.f0c96095.jpg";